import { useTheme } from "@mui/material/styles";

export default function Line({ x1, x2, y, y2, color, position, handleClick }) {
  const theme = useTheme();
  // ✅ modern color system
  const wireColor = (value) => {
    if (value === 1) return theme.palette.levels.green; // green (correct / active)
    if (value === 0) return theme.palette.levels.red; // red (wrong)
    return "#999"; // neutral visible
  };

  const stroke = wireColor(color);
  const isActive = color === 1;

  return (
    <>
      {/* ✅ START DOT */}
      {(position === "start" || position === "both") && (
        <circle
          cx={x1 + 10}
          cy={y}
          r="10"
          fill={stroke}
          style={{
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
          onMouseEnter={(e) => e.target.setAttribute("r", "12")}
          onMouseLeave={(e) => e.target.setAttribute("r", "10")}
          onClick={handleClick}
        />
      )}

      {/* ✅ MAIN LINE */}
      <line
        x1={x1}
        y1={y}
        x2={position === "angle" ? x1 : x2}
        y2={position === "angle" ? y2 : y}
        stroke={stroke}
        strokeWidth="3"
        className={isActive ? "flow" : ""}
      />

      {/* ✅ SECOND LINE FOR ANGLES */}
      {position === "angle" && (
        <line
          x1={x1}
          y1={y2}
          x2={x2}
          y2={y2}
          stroke={stroke}
          strokeWidth="3"
          className={isActive ? "flow" : ""}
        />
      )}

      {/* ✅ END DOT */}
      {(position === "end" || position === "both") && (
        <circle
          cx={x2 + 10}
          cy={y}
          r="10"
          fill={stroke}
          style={{
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
        />
      )}
    </>
  );
}
